import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button } from 'react-bootstrap';
import axios from 'axios';
import Navbar from '../../components/navbar/navbar.jsx'
import apinode from '../../services/apinode.js';
import { BsDownload } from 'react-icons/bs';
import { toast } from 'react-toastify';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';

const PendingStockTransactions = () => {
    const [pendingTransactions, setPendingTransactions] = useState([]);
    const [isLoading, setLoading] = useState(false)

    useEffect(() => {
        // Simulação de uma chamada assíncrona para obter as transações pendentes do estoque
        const fetchPendingTransactions = async () => {
            setLoading(true)
            try {
                // Substitua esta lógica pela chamada real à sua API ou método de obtenção das transações pendentes
                const response = await apinode(`/erpflex/transacoes/${localStorage.idconta}`);

                setPendingTransactions(response.data);
                setLoading(false)
            } catch (error) {
                setLoading(false)
                toast.error('Erro ao buscar transações pendentes:', error);
            }
        };

        fetchPendingTransactions();
    }, []);

    return (
        <>
            <Navbar />
            <div className='mt-page'>
                <h2>Transações de Estoque Pendentes e Concluidas</h2>
                <div>
                    <ReactHtmlTableToExcel
                        id="exportButton"
                        className="btn btn-primary export-button"
                        table="table-to-xls"
                        filename="transacoes_pendentes"
                        sheet="TransacoesPendentes"
                        buttonText={<><i className="fas fa-file-excel"></i> Exportar para Excel</>}
                    />

                </div>
                <div className="table-responsive">
                    {isLoading ? (
                        <div className="table-responsive d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Carregando...</span>
                            </div>
                        </div>

                    ) : (
                        <table id="table-to-xls" className="table table-striped table-bordered" style={{ fontSize: '12px' }}>
                            <thead>
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Data Inclusão</th>
                                    <th scope="col">Pedido</th>
                                    <th scope="col">Sku</th>
                                    <th scope="col">Produto</th>
                                    <th scope="col">Quantidade</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">ID Transaction</th>
                                    <th scope="col">transaction Date Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pendingTransactions.map(transaction => (
                                    <tr key={transaction.codigo}>
                                        <td>{transaction.codigo}</td>
                                        <td>
                                            {transaction.datainclusao ?
                                                new Date(transaction.datainclusao).toLocaleString() :
                                                null}
                                        </td>
                                        <td>
                                            <a href={`/pedido/editar/${transaction.pedido}`} target="_blank" rel="noopener noreferrer">
                                                {transaction.pedido}
                                            </a>
                                        </td>
                                        <td>{transaction.sku}</td>
                                        <td>{transaction.descricao}</td>
                                        <td>{transaction.qtd.toFixed(2)}</td>
                                        <td>
                                            {transaction.exportado === 'S' ? (
                                                <span className="badge bg-success">Concluída</span>
                                            ) : (
                                                <span className="badge bg-danger">Não concluída</span>
                                            )}
                                        </td>
                                        <td>{transaction.idreceita}</td>
                                        <td>
                                            {transaction.datahora ?
                                                new Date(transaction.datahora).toLocaleString() :
                                                null}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

            </div>


        </>
    );
};

export default PendingStockTransactions;
